import { Flex } from 'antd';
import styled from 'styled-components';

export const LayoutContainer = styled(Flex)`
    align-items: flex-start;
    gap: 108px;
`;

export const InviteCardWrapper = styled.div`
    width: 305px;
    min-height: 456px;
    flex-shrink: 0;
`;

export const StoreSetupWrapper = styled.div`
    width: 867px;
    min-height: 577px;
    flex-shrink: 0;
`;
